import styled, { css } from "styled-components";
import { BasedTitle } from "./components/BasedTitle";
import { BasedText } from "./components/BasedText";
import { iTextStyleProps, iTilteStyleProps } from "./types";

export const StyledTitle = styled(BasedTitle)<iTilteStyleProps>`
  color: ${({ color }) => color};
  align-self: ${({ alignSelf }) => alignSelf};
  ${({ titleStyle }) => {
    switch (titleStyle) {
      case "default":
        return css`
          font-size: 2.6rem;
          font-weight: 700;
        `;
      case "heading2":
        return css`
          font-size: 2.2rem;
          font-weight: 700;
        `;
      case "heading3":
        return css`
          font-size: 1.8rem;
          font-weight: 700;
          height: 3.6rem;
        `;
      case "heading4":
        return css`
          font-size: 1.4rem;
          font-weight: 700;
        `;
    }
  }}
`;

export const StyledText = styled(BasedText)<iTextStyleProps>`
  font-weight: ${({ weigth }) => weigth};
  color: ${({ color }) => color};
  text-align: ${({ textAlign }) => textAlign};

  ${({ textStyle }) => {
    switch (textStyle) {
      case "default":
        return css`
          font-size: 1.6rem;
        `;
      case "body":
        return css`
          font-size: 1.4rem;
        `;
      case "body-600":
        return css`
          font-size: 1.4rem;
        `;
      case "caption":
        return css`
          font-size: 1.4rem;
        `;
    }
  }}
`;
